/*
 *  Copyright (C) 2017 Atelier Cartographique <contact@atelier-cartographique.be>
 *
 *  This program is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, version 3 of the License.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import * as debug from 'debug';
import { DIV, A, NodeOrOptional } from 'sdi/components/elements';
import { getRoot, getAppManifest, getRootUrl } from 'sdi/app';
import { fromRecord } from 'sdi/locale';
import { appDisplayName } from 'sdi/source';
import { fromNullable, none } from 'fp-ts/lib/Option';
import { renderConnexionSelect } from 'qa/src/components/header-select';
import { getThemeObject } from '../queries/app';

const logger = debug('sdi:header');

const renderTitle = (appCodename: string) =>
    getAppManifest(appCodename)
        .chain(appDisplayName)
        .map<string>(n => fromRecord(n))
        .getOrElse(appCodename);

const appElementDefault = (): NodeOrOptional => none;

export interface Link {
    url: string;
    name: string;
}

export const header = (appCodename: string, appElement = appElementDefault) =>
    DIV(
        { className: 'header' },
        A(
            {
                href: getRoot(),
            },
            DIV({ className: 'app-title' }, renderTitle(appCodename))
        ),
        getThemeObject().map(theme =>
            fromNullable(theme?.name).map(themeName =>
                A(
                    {
                        href: `${getRoot()}qa/mapAndTable/${theme?.slug}`,
                    },
                    DIV(
                        {
                            className: 'app-title',
                        },
                        themeName
                    )
                )
            )
        ),
        DIV({ className: 'app-listwrapper' }, appElement()),
        DIV(
            { className: 'app-admin' },
            A({ href: '/admin/' }, 'Interface d’administration')
        ),
        DIV(
            { className: 'about-link' },
            A({ href: `${getRootUrl('qa/about')}` }, 'À propos')
        ),
        DIV(
            { className: 'header-toolbar' },
            DIV(
                {
                    className: 'logout activate',
                    // onClick: tryLogout
                },
                renderConnexionSelect()
                // A({ href: getApiUrl('geodata/accounts/openstreetmap/login/?process=login') }, tr.core('osmConnection'))
                // A({ href: 'http://localhost:8000/api/geodata/accounts/openstreetmap/login/?process=login' }, tr.core('logout'))

                // documentationLink(),
                // langSwitch(),
            )
        )
    );

export default header;

logger('loaded');
